import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McoRbtLineList = ({ mcoRbtId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!mcoRbtId) return;

      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcoRbtId', mcoRbtId));
    },
    [mcoRbtId],
  );

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
  };

  return <EntityList entity="MCO_RBT_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />;
};
